import React from 'react';
import {Block, BlockHead, BlockHeadContent, BlockTitle} from '../../../../components/block/Block';
import Button from '../../../../components/button/Button';
import Icon from '../../../../components/icon/Icon';
import {Card, CardBody, Form, Row, Col} from 'reactstrap';
import RegionForm from './RegionForm';
import {useNavigate} from 'react-router-dom';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import {IRegion} from '../interfaces/IRegion';
import {regionFormSchema} from './RegionUpdate';
import {regionApi} from '../../../../api';
import {useTranslation} from 'react-i18next';

const RegionCreate = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const methods = useForm<IRegion>({
    resolver: yupResolver(regionFormSchema),
  });

  const onFormSubmit = async (formData: IRegion) => {
    const {data} = await regionApi.createRegion(formData);
    if (data) {
      navigate('/app/admin/regions');
    }
  };

  return (
    <Block size="lg" className="mt-3">
      <BlockHead>
        <BlockHeadContent>
          <div className="row align-items-center gx-0 gx-lg-2">
            <div className="col-md-10 col-12">
              <BlockTitle tag="h4">{t('administrator.regions.regionCreate')}</BlockTitle>
            </div>
            <div className="col-md-2 col-12 text-end">
              <Button
                className="btn-block"
                color="secondary"
                onClick={() => {
                  navigate('/app/admin/regions');
                }}
              >
                <Icon name="arrow-long-left" />
                {t('general.back')}
              </Button>
            </div>
          </div>
        </BlockHeadContent>
      </BlockHead>
      <Card className="card-bordered card-preview">
        <CardBody>
          <FormProvider {...methods}>
            <Form onSubmit={methods?.handleSubmit(onFormSubmit)} className="py-3">
              <RegionForm
                defaultState={methods?.formState?.defaultValues as IRegion}
                register={methods?.register}
                errors={methods?.formState?.errors}
              />
              <Row>
                <Col>
                  <Row>
                    <Col className={'text-end'}>
                      <Button color="primary">
                        <Icon name="plus-sm" />
                        {t('general.create')}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </FormProvider>
        </CardBody>
      </Card>
    </Block>
  );
};

export default RegionCreate;
